<i18n src="../../locales/lang.json"></i18n>

<template>
  <div v-if="isvisible == true" v-bind:class="{show : isvisible == true, displayblock : isvisible == true}" class="modal" tabindex="-1">
    <div class="modal-dialog" v-bind:class="size">
      <div class="modal-content">
        <div class="modal-header" v-if="showheader == 'true'">
          <h5 class="modal-title" v-if="showtitle == 'true'">{{title}}</h5>
          <button type="button" class="close" @click="close()">&times;</button>
        </div>
        <div class="modal-body p-0">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'modal-no-ref',
    components: {
    },
    props: {
      showtitle: {
        required: false,
        type: String,
        default: "true"
      },
      showheader: {
        required: false,
        type: String,
        default: "true"
      },
      title: {
        required: false,
        type: String,
        default: null
      },
      onsave: {
        required: false,
        type: Function,
        default: null
      },
      show: {
        required: false,
        type: String,
        default: null
      },
      size: {
        required: false,
        type: String,
        default: null
      }
    },
    data() {
      return {
        isvisible: this.show == "true"
      }
    },
    methods: {
      getId() {
        return this._uid;
      },
      open() {
        this.isvisible = true;
      },
      close() {
        this.isvisible = false;
      },
      doSave() {
        if (this.onsave != null) {
          this.onsave();
        }
      }
    },
    created() {

    },
    mounted() {
      //if (this.show != null && this.show= 'true') {
      //  $('#modal-control' + getId()).modal();
      //}
    }
  }
</script>

<style scoped>
  .displayblock {
    display: block;
  }

  @media (max-width: 768px) {
    .modal {
      width: 100%;
      max-width: 100%;
      height: 100vh;
      margin: 0;
      min-height: 100vh;
    }

    .modal-dialog {
      margin: 0 !important;
      padding: 0px !important;
      height: 100%;
    }

    .modal-content {
      height: calc(100vh - 170px) !important;
      flex: none !important;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/modals/modal-no-ref.vue